import React, { Component } from 'react';
import propTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import ArrowDown from '@material-ui/icons/ArrowDropDown';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';

class SocialSelect extends Component {

  constructor(props) {
    super(props);

    this.state = {
      popoverOpen: null,
      selectItem: null,
    };
  }

  handleOpenPopover = (event) => {
    this.setState({
      popoverOpen: event.currentTarget,
    });
  }

  handleClosePopover = () => {
    this.setState({
      popoverOpen: null,
    });
  }

  handleSelectItem = (item) => {
    this.setState({
      selectItem: item.id,
    });

    this.props.selectItem(item);
    this.handleClosePopover();
  }

  renderPopOver() {
    const { classes } = this.props;

    const items = this.props.items.map(item => (
      <div
        className={classes.itemStyle}
        onClick={() => this.handleSelectItem(item)}
      >
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {item.leftIcon}
          <span className={classes.itemTextStyle}>{item.text}</span>
        </div>
        <div />
        {/* <Radio
          color="primary"
          checked={this.state.selectedItem === item.id}

        /> */}
      </div>
    ));

    return (
      <Popover
        open={this.state.popoverOpen}
        anchorEl={this.state.popoverOpen}
        onClose={this.handleClosePopover}
      >
        <div className={classes.popoverStyle}>
          <Typography className={classes.titleStyle}>{this.props.title}</Typography>
          {items}
        </div>
      </Popover>
    );
  }


  render() {
    const { classes } = this.props;
    return (
      <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
        {this.renderPopOver()}
        <div
          className={classes.containerStyle}
          onClick={this.handleOpenPopover}
        >
          {this.props.icon}
          {this.props.value}
          <ArrowDown style={{ marginLeft: 5 }} />
        </div>
      </div>

    );
  }
}

SocialSelect.propTypes = {
  icon: propTypes.any,
  value: propTypes.string,
  title: propTypes.string,
  items: propTypes.array,
  classes: propTypes.object.isRequired,
  selectItem: propTypes.func,
};


SocialSelect.defaultProps = {
  icon: null,
  value: '',
  title: '',
  items: [],
  selectItem: () => {},
};

const styles = () => ({
  containerStyle: {
    borderColor: 'grey',
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 3,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '5px 0',
    padding: 3,
    cursor: 'pointer',
  },
  itemStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 3,
    cursor: 'pointer',
  },
  titleStyle: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  itemTextStyle: {
    marginLeft: 10,
    marginRight: 20,
  },
  popoverStyle: {
    padding: 10,
  },
});


export default withStyles(styles)(SocialSelect);



// WEBPACK FOOTER //
// ./src/app/components/select/social-select.js